import React from "react";
import { I_KonkurBookletYear, I_KonkurBookletCategory, I_KonkurBookletPdf } from "../../../../Models/interfaces";
import { AiOutlineDown, AiOutlineRight } from "react-icons/ai";
import Spinner from "../../../../Utils/ColoredSpinner/Spinner";
import CategoryItem from "./CategoryItem";

interface YearItemProps {
  year: I_KonkurBookletYear;
  isExpanded: boolean;
  onToggle: (yearId: number) => void;
  categories: I_KonkurBookletCategory[];
  loading: boolean;
  expandedCategories: Set<number>;
  onToggleCategory: (categoryId: number) => void;
  categoryPdfsMap: Record<number, I_KonkurBookletPdf[]>;
  loadingPdfs: Record<number, boolean>;
  onDownload: (pdf: I_KonkurBookletPdf) => void;
  onPurchase: (pdf: I_KonkurBookletPdf) => void;
}

const YearItem: React.FC<YearItemProps> = ({
  year,
  isExpanded,
  onToggle,
  categories,
  loading,
  expandedCategories,
  onToggleCategory,
  categoryPdfsMap,
  loadingPdfs,
  onDownload,
  onPurchase,
}) => {
  return (
    <div className="border border-gray-200 rounded-md">
      <div
        className="flex items-center justify-between p-3 cursor-pointer hover:bg-gray-100 transition"
        onClick={() => onToggle(year.id)}
      >
        <span className="font-medium text-gray-800">{year.title}</span>
        <span className="text-gray-500">
          {isExpanded ? <AiOutlineDown /> : <AiOutlineRight />}
        </span>
      </div>

      {isExpanded && (
        <div className="border-t border-gray-200 p-3 pr-6 space-y-2">
          {loading ? (
            <div className="flex justify-center py-4">
              <Spinner />
            </div>
          ) : categories.length === 0 ? (
            <p className="text-sm text-gray-400">دسته‌بندی موجود نیست.</p>
          ) : (
            categories.map((cat) => (
              <CategoryItem
                key={cat.id}
                category={cat}
                isExpanded={expandedCategories.has(cat.id)}
                onToggle={onToggleCategory}
                pdfs={categoryPdfsMap[cat.id] || []}
                loading={loadingPdfs[cat.id] || false}
                onDownload={onDownload}
                onPurchase={onPurchase}
              />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default YearItem;